import React from 'react';
import PropTypes from 'prop-types';

const Transfers = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.72 7.46L19 3.71C18.965 3.67369 18.9199 3.6488 18.8705 3.63859C18.8212 3.62838 18.7699 3.63333 18.7234 3.6528C18.6769 3.67226 18.6374 3.70533 18.61 3.74766C18.5826 3.78999 18.5687 3.83961 18.57 3.89V6.55H3.28C2.99092 6.55 2.71367 6.66484 2.50926 6.86926C2.30484 7.07367 2.19 7.35092 2.19 7.64C2.19 7.78315 2.2182 7.92488 2.27297 8.05713C2.32775 8.18937 2.40804 8.30954 2.50926 8.41075C2.61047 8.51197 2.73063 8.59226 2.86288 8.64703C2.99512 8.70181 3.13686 8.73 3.28 8.73H18.54V11.39C18.5387 11.4404 18.5526 11.49 18.58 11.5323C18.6074 11.5747 18.6469 11.6077 18.6934 11.6272C18.7399 11.6467 18.7912 11.6516 18.8405 11.6414C18.8899 11.6312 18.935 11.6063 18.97 11.57L22.72 7.82C22.7442 7.79668 22.7634 7.76872 22.7766 7.7378C22.7897 7.70687 22.7965 7.67361 22.7965 7.64C22.7965 7.6064 22.7897 7.57314 22.7766 7.54221C22.7634 7.51129 22.7442 7.48333 22.72 7.46Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M1.27 16.54L5 20.3C5.03661 20.3318 5.08137 20.3527 5.12924 20.3604C5.17711 20.3681 5.22618 20.3623 5.27091 20.3436C5.31564 20.3248 5.35423 20.294 5.38235 20.2545C5.41046 20.215 5.42697 20.1684 5.43 20.12V17.45H20.72C21.0091 17.45 21.2863 17.3352 21.4907 17.1307C21.6952 16.9263 21.81 16.6491 21.81 16.36C21.81 16.0709 21.6952 15.7937 21.4907 15.5893C21.2863 15.3848 21.0091 15.27 20.72 15.27H5.46V12.6C5.46909 12.5429 5.45809 12.4844 5.42888 12.4344C5.39966 12.3845 5.35403 12.3463 5.29977 12.3262C5.24551 12.3062 5.18598 12.3055 5.13132 12.3245C5.07666 12.3434 5.03025 12.3807 5 12.43L1.27 16.19C1.24609 16.2124 1.22703 16.2396 1.214 16.2697C1.20097 16.2998 1.19424 16.3322 1.19424 16.365C1.19424 16.3978 1.20097 16.4303 1.214 16.4604C1.22703 16.4904 1.24609 16.5176 1.27 16.54Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

Transfers.propTypes = {
  fill: PropTypes.string,
};

export default Transfers;
